/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from "@emotion/react";
import React from "react";
import { mixin } from "styles/mixin";

type Props = {
  className?: string;
  cssOverride?: SerializedStyles;
  dark?: boolean;
  lightColor?: string;
  darkColor?: string;
  size?: number;
};

export const TextLogo: React.FC<Props> = ({
  className,
  cssOverride,
  dark = false,
  lightColor = "#444444",
  darkColor = "#ffffff",
  size = 30,
}) => {
  const color = dark ? darkColor : lightColor;
  return (
    <div
      css={[
        css`
          ${mixin.changeThemeFill};
          fill: ${color};
          display: flex; // MEMO: 縦の余分な計算ピクセルを消す
        `,
        cssOverride,
      ]}
      className={`${className ? className : ""}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 0 630.55 91.75"
      >
        <g>
          <polygon points="306.79 14.72 276.83 80.17 287.66 80.17 295.16 63.68 298.44 56.43 308.7 32.84 319.1 56.44 322.33 63.68 329.89 80.17 340.64 80.17 310.63 14.72 306.79 14.72" />
          <polygon points="306.79 14.72 276.83 80.17 287.66 80.17 295.16 63.68 298.44 56.43 308.7 32.84 319.1 56.44 322.33 63.68 329.89 80.17 340.64 80.17 310.63 14.72 306.79 14.72" />
          <polygon points="76.48 14.72 63.32 14.72 37.78 40.69 37.78 14.72 27.89 14.72 27.89 80.17 37.78 80.17 37.78 53.15 39.82 51.03 63.42 80.17 76.71 80.17 46.88 44.21 76.48 14.72" />
          <polygon points="76.48 14.72 63.32 14.72 37.78 40.69 37.78 14.72 27.89 14.72 27.89 80.17 37.78 80.17 37.78 53.15 39.82 51.03 63.42 80.17 76.71 80.17 46.88 44.21 76.48 14.72" />
          <polygon points="128.79 14.72 98.83 80.17 109.66 80.17 117.16 63.68 120.44 56.43 130.7 32.84 141.1 56.44 144.33 63.68 151.89 80.17 162.64 80.17 132.63 14.72 128.79 14.72" />
          <polygon points="128.79 14.72 98.83 80.17 109.66 80.17 117.16 63.68 120.44 56.43 130.7 32.84 141.1 56.44 144.33 63.68 151.89 80.17 162.64 80.17 132.63 14.72 128.79 14.72" />
          <rect x="375.48" y="14.72" width="9.89" height="65.45" />
          <rect x="375.48" y="14.72" width="9.89" height="65.45" />
          <path d="M453.47,15a32.19,32.19,0,0,0-14.7,3.62A35.47,35.47,0,0,0,427,28.3a29,29,0,0,0-6.3,18.33,33,33,0,0,0,2.62,13.07,32.23,32.23,0,0,0,17.58,17.66,31.66,31.66,0,0,0,12.37,2.5,32.38,32.38,0,0,0,16.22-4.38l.48-.27V63.74L468.46,65A23.89,23.89,0,0,1,453,71a21.81,21.81,0,0,1-16-6.93,24,24,0,0,1-6.82-17.49A22.23,22.23,0,0,1,437,30.53a21.9,21.9,0,0,1,16-6.87,23.23,23.23,0,0,1,15.48,5.75L470,30.75V19.34l-.48-.27A32.08,32.08,0,0,0,453.47,15Z" />
          <path d="M453.47,15a32.19,32.19,0,0,0-14.7,3.62A35.47,35.47,0,0,0,427,28.3a29,29,0,0,0-6.3,18.33,33,33,0,0,0,2.62,13.07,32.23,32.23,0,0,0,17.58,17.66,31.66,31.66,0,0,0,12.37,2.5,32.38,32.38,0,0,0,16.22-4.38l.48-.27V63.74L468.46,65A23.89,23.89,0,0,1,453,71a21.81,21.81,0,0,1-16-6.93,24,24,0,0,1-6.82-17.49A22.23,22.23,0,0,1,437,30.53a21.9,21.9,0,0,1,16-6.87,23.23,23.23,0,0,1,15.48,5.75L470,30.75V19.34l-.48-.27A32.08,32.08,0,0,0,453.47,15Z" />
          <polygon points="543.94 14.72 543.94 40.2 515.66 40.2 515.66 14.72 505.73 14.72 505.73 80.17 515.66 80.17 515.66 49.6 543.94 49.6 543.94 80.17 553.79 80.17 553.79 14.72 543.94 14.72" />
          <polygon points="543.94 14.72 543.94 40.2 515.66 40.2 515.66 14.72 505.73 14.72 505.73 80.17 515.66 80.17 515.66 49.6 543.94 49.6 543.94 80.17 553.79 80.17 553.79 14.72 543.94 14.72" />
          <rect x="595.83" y="14.72" width="9.89" height="65.45" />
          <rect x="595.83" y="14.72" width="9.89" height="65.45" />
          <polygon points="252.91 14.72 235.92 58.31 219.07 14.72 216.59 14.72 199.9 58.29 182.85 14.72 172.06 14.72 198.19 80.17 201.63 80.17 217.85 37.94 234.25 80.17 237.57 80.17 263.64 14.72 252.91 14.72" />
          <polygon points="252.91 14.72 235.92 58.31 219.07 14.72 216.59 14.72 199.9 58.29 182.85 14.72 172.06 14.72 198.19 80.17 201.63 80.17 217.85 37.94 234.25 80.17 237.57 80.17 263.64 14.72 252.91 14.72" />
        </g>
      </svg>
    </div>
  );
};
